import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, FloatingLabel, Row, Col, Container, Accordion } from 'react-bootstrap';
import ContratoService from '../../../../services/contrato';
import { Link } from 'react-router-dom';
import Exportar from '../../../../components/shared/export'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDatabase } from '@fortawesome/free-solid-svg-icons';



const FormBusca = (props) => {
    const [processo, setProcesso] = useState("");
    const [situacao, setSituacao] = useState("");
    const [unidadeGestora, setUnidadeGestora] = useState("");
    const [ano, setAno] = useState("");
    const [numero, setNumero] = useState("");
    const [contratado, setContratado] = useState("");
    const [cnpj, setCnpj] = useState("");
    const [dataInicial, setDataInicial] = useState("");
    const [dataFinal, setDataFinal] = useState("");
    const [objeto, setObjeto] = useState("");
    const [palavraChave, setPalavrachave] = useState("");
    const [mostra, setMostra] = useState(true);
    const pathName = window.location.pathname;

    const getTipo = (path) => {
        switch (path) {
            case '/transparencia/contratos/expomacuco/2025':
                setAno("2025");
                setMostra(false);
                return { service: ContratoService.buscarExpo, type: "object" };

            case '/transparencia/contratos/expomacuco/2024':
                setAno("2024");
                setMostra(false);
                return { service: ContratoService.buscarExpo, type: "object" };

            case '/transparencia/contratos/expomacuco/2023':
                setAno("2023");
                setMostra(false);
                return { service: ContratoService.buscarExpo, type: "object" };

            case '/transparencia/contratos/expomacuco/anteriores':
                setMostra(false);
                return { service: ContratoService.buscarExpoAnt, type: "object" };

            default:
                setMostra(true);
                return { service: ContratoService.buscar, type: "string" };
        }
    };

    const busca = async (query) => {
        if (query === "") {
            await props.fetchContratosIn()
            setProcesso("")
            setNumero("")
            setContratado("")
            setCnpj("")
            setObjeto("")
            setPalavrachave("")
            setDataFinal("")
            setDataInicial("")
        } else {
            const { service, type } = getTipo(pathName);

            let response;
            if (type === "object") {
                // services buscarExpo e buscarExpoAnt
                response = await service(ano ? { ano, ...query } : query);
            } else {
                // service buscar → já espera string completa
                response = await service(query);
            }

            if (response.data.length >= 1) {
                props.setContratos(response.data);
                props.setVazio(false);
            } else {
                props.setVazio(true);
            }

            // limpa campos
            setProcesso("")
            setNumero("")
            setContratado("")
            setPalavrachave("")
            setCnpj("")
            setObjeto("")
        }
    }

    const preparaQuery = async () => {
        let queryObj = {};
        let queryStr = "";

        if (situacao !== "false" && situacao !== "") {
            queryObj.situacao = situacao;
            queryStr += `&situacao=${encodeURI(situacao)}`;
        }
        if (numero) {
            queryObj.numero = numero;
            queryStr += `&numero=${numero}`;
        }
        if (unidadeGestora !== "false" && unidadeGestora !== "") {
            queryObj.unidadeGestora = unidadeGestora;
            queryStr += `&unidadeGestora=${encodeURI(unidadeGestora)}`;
        }
        if (contratado) {
            queryObj.contratado = contratado;
            queryStr += `&contratado=${encodeURI(contratado)}`;
        }
        let termoBusca = objeto || palavraChave;
        if (termoBusca) {
            queryObj.objeto = termoBusca;
            queryStr += `&objeto=${encodeURIComponent(termoBusca)}`;
        }
        if (dataInicial) {
            queryObj.dataInicial = dataInicial;
            queryStr += `&dataInicial=${dataInicial}`;
        }
        if (dataFinal) {
            queryObj.dataFinal = dataFinal;
            queryStr += `&dataFinal=${dataFinal}`;
        }
        if (cnpj) {
            queryObj.cnpj = cnpj;
            queryStr += `&cnpj=${cnpj}`;
        }
        if (ano) {
            queryObj.ano = ano;
            queryStr += `&ano=${ano}`;
        }
        if (processo) {
            queryObj.processo = processo;
            queryStr += `&processo=${processo}`;
        }

        return { queryObj, queryStr };
    };

    const handleKeyDown = async (e) => {
        e.preventDefault();
        let { queryObj, queryStr } = await preparaQuery();

        const { service, type } = getTipo(pathName);

        if (type === "object") {
            await busca(queryObj);
        } else {
            await busca(queryStr);
        }
    };
    useEffect(() => {
        getTipo(window.location.pathname);
    }, [window.location.pathname]);


    return (
        <Fragment>
            <Container>
                <div className="da-espaco">
                    <Row xs={1} lg={5}>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="objeto">
                                <FloatingLabel
                                    label="Objeto do contrato"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        type="text"
                                        name="objeto"
                                        value={objeto}
                                        onChange={e => setObjeto(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="processo">
                                <FloatingLabel
                                    label="Número do Processo (sem ano)"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        type="number"
                                        name="processo"
                                        value={processo}
                                        onChange={e => setProcesso(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        {mostra ?
                            <Col xs={12} lg={4}>
                                <Form.Group className="mb-3" controlId="ano">
                                    <FloatingLabel
                                        label="Ano do Processo"
                                        className="mb-3"
                                    >
                                        <Form.Control
                                            type="number"
                                            name="ano"
                                            value={ano}
                                            onChange={e => setAno(e.target.value)} />
                                    </FloatingLabel>
                                </Form.Group>
                            </Col> : null}
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="numero">
                                <FloatingLabel
                                    label="Número do Contrato"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        type="number"
                                        name="numero"
                                        value={numero}
                                        onChange={e => setNumero(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={3}>
                            <Form.Group className="mb-3" controlId="contratante">
                                <FloatingLabel
                                    label="Contratante"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        aria-label="Contratante"
                                        name="unidadeGestora"
                                        onChange={e => setUnidadeGestora(e.target.value)}
                                    >
                                        <option value="false">TODAS</option>
                                        <option value="Prefeitura de Macuco">Prefeitura Municipal de Macuco</option>
                                        <option value="Fundo Municipal de Saúde">Fundo Municipal de Saúde</option>
                                        <option value="Fundo Municipal da Educação">Fundo Municipal da Educação</option>
                                        <option value="Fundo Municipal de Assistência Social">Fundo Municipal de Assistência Social</option>
                                        <option value="Fundo Municipal da Criança e do Adolescente">Fundo Municipal da Criança e do Adolescente</option>
                                        <option value="Fundo Municipal de Meio Ambiente">Fundo Municipal de Meio Ambiente</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={3}>
                            <Form.Group className="mb-3" controlId="Situação">
                                <FloatingLabel
                                    label="Situação"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        aria-label="Situação"
                                        name="situacao"
                                        onChange={e => setSituacao(e.target.value)}
                                    >
                                        <option value="false">TODAS</option>
                                        <option value="Ativo">Ativo</option>
                                        <option value="Concluído">Concluído</option>
                                        <option value="Cancelado">Cancelado</option>
                                        <option value="Rescindido">Rescindido</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={3}>
                            <Form.Group className="mb-3" controlId="dataInicial">
                                <FloatingLabel
                                    label="Data Inicial"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        type="date"
                                        name="dataInicial"
                                        value={dataInicial}
                                        onChange={e => setDataInicial(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={3}>
                            <Form.Group className="mb-3" controlId="dataFinal">
                                <FloatingLabel
                                    label="Data Final"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        type="date"
                                        name="dataFinal"
                                        value={dataFinal}
                                        onChange={e => setDataFinal(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="objeto">
                                <FloatingLabel
                                    label="Palavra-chave"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        type="text"
                                        name="palavraChave"
                                        value={palavraChave}
                                        onChange={e => setPalavrachave(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={5}>
                            <Form.Group className="mb-3" controlId="contratado">
                                <FloatingLabel
                                    label="Razão Social do Contratado"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        type="text"
                                        name="contratado"
                                        value={contratado}
                                        onChange={e => setContratado(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={5}>
                            <Form.Group className="mb-3" controlId="cnpj">
                                <FloatingLabel
                                    label="CPF/CNPJ"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        type="text"
                                        name="cnpj"
                                        value={cnpj}
                                        onChange={e => setCnpj(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Button onClick={async (e) => handleKeyDown(e)} type='button' variant='primary'>Buscar</Button>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Link to='/contratos'>
                                <Button type='button' variant='danger'>Voltar</Button>
                            </Link>
                        </Col>
                    </Row>
                    <Accordion>
                        <Accordion.Item eventKey="0">
                            <Accordion.Header><strong>Dados Abertos <FontAwesomeIcon icon={faDatabase} /></strong></Accordion.Header>
                            <Accordion.Body>
                                <Row xs={1}>
                                    <Col xs={12}>
                                        <Exportar data={props.contratos} nome={"Contratos"} />
                                    </Col>
                                </Row>
                                <br />
                                <Row xs={1}>
                                    <Col xs={12}>
                                        <a href="https://documenter.getpostman.com/view/19738229/2sA3BrWp4P#c168cd83-067f-484c-9726-2b3463e8fa78" target='_blank'>
                                            <Button>API e sua documentação</Button>
                                        </a>
                                    </Col>
                                </Row>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                </div>
            </Container>
        </Fragment>
    )
}

export default FormBusca